import { CmsBannerId } from "../../../cms/cms-banners/cm-banner-id/cms-banner-id";
import { OfferConfiguration } from "../../../configurations/config-data-sections/link-to-offer.configuration";
import { IServiceFactory } from "../../../service-factory.interface";
import { IOffer } from "../../player-offerings.service";

export abstract class OfferBase implements IOffer {

    constructor(protected services: IServiceFactory, protected offerConfig: OfferConfiguration) {
    }

    abstract render(): React.ReactNode;

    abstract shouldUseLinkToOfferAnimation(): boolean;

    isHighPriorityOffer(): boolean {
        return false;
    }
    
    shouldBeVisible(): boolean {
        return this.offerConfig?.display;
    }

    get bannerId(): CmsBannerId {
        return new CmsBannerId(this.offerConfig.componentID, this.offerConfig.templateID, null);
    }

    private _offerShown: boolean = false;

    private _getSessionStageKey() {
        return `offer_${this.id}_shown`;
    }

    get offerShown() {
        try {
            //TODO: change this code when sessionStorage service is added
            const isShown = window.sessionStorage.getItem(this._getSessionStageKey());
            return isShown === "true";
        }
        catch (err) {
            this.services.logger.error(`get offerShown error`, err);
            return this._offerShown;
        }
    }

    set offerShown(offerShown: boolean) {
        try {
            this._offerShown = offerShown;
            //TODO: change this code when sessionStorage service is added
            window.sessionStorage.setItem(this._getSessionStageKey(), offerShown? "true" : "false");
        }
        catch (err) {
            this.services.logger.error(`set offerShown error`, err);
        }
    }

    abstract readonly id: string;
    abstract readonly analyticsCategory: string;
}
